import { BehaviorValue, ReadingValue } from '@olympus/ngx-shared';

export function readingsStateInitializer(): ReadingAppState {
  return {
    ReadingGateAmplitudeI: new BehaviorValue(),
    ReadingGateAmplitudeA: new BehaviorValue(),
    ReadingGateAmplitudeB: new BehaviorValue(),
    ReadingGateAmplitudeC: new BehaviorValue(),
    ReadingGateAmplitudeD: new BehaviorValue(),

    ReadingGatePositionI: new BehaviorValue(),
    ReadingGatePositionA: new BehaviorValue(),
    ReadingGatePositionB: new BehaviorValue(),
    ReadingGatePositionC: new BehaviorValue(),
    ReadingGatePositionD: new BehaviorValue(),

    ReadingCursorAmplitudeMMinusR: new BehaviorValue(),
    ReadingCursorUltrasoundMMinusR: new BehaviorValue(),
    ReadingCursorScanMMinusR: new BehaviorValue(),
    ReadingCursorIndexMMinusR: new BehaviorValue(),
    ReadingCursorScanD: new BehaviorValue(),
    ReadingCursorIndexD: new BehaviorValue(),

    ReadingThicknessGateI: new BehaviorValue(),
    ReadingThicknessGateA: new BehaviorValue(),
    ReadingThicknessGateB: new BehaviorValue(),
    ReadingThicknessGateC: new BehaviorValue(),
    ReadingThicknessGateD: new BehaviorValue(),

    ReadingThicknessGateIMinusGateA: new BehaviorValue(),
    ReadingThicknessGateIMinusGateB: new BehaviorValue(),
    ReadingThicknessGateIMinusGateC: new BehaviorValue(),
    ReadingThicknessGateIMinusGateD: new BehaviorValue(),

    ReadingThicknessGateAMinusGateI: new BehaviorValue(),
    ReadingThicknessGateAMinusGateB: new BehaviorValue(),
    ReadingThicknessGateAMinusGateC: new BehaviorValue(),
    ReadingThicknessGateAMinusGateD: new BehaviorValue(),

    ReadingThicknessGateBMinusGateI: new BehaviorValue(),
    ReadingThicknessGateBMinusGateA: new BehaviorValue(),
    ReadingThicknessGateBMinusGateC: new BehaviorValue(),
    ReadingThicknessGateBMinusGateD: new BehaviorValue(),

    ReadingThicknessGateCMinusGateI: new BehaviorValue(),
    ReadingThicknessGateCMinusGateA: new BehaviorValue(),
    ReadingThicknessGateCMinusGateB: new BehaviorValue(),
    ReadingThicknessGateCMinusGateD: new BehaviorValue(),

    ReadingThicknessGateDMinusGateI: new BehaviorValue(),
    ReadingThicknessGateDMinusGateA: new BehaviorValue(),
    ReadingThicknessGateDMinusGateB: new BehaviorValue(),
    ReadingThicknessGateDMinusGateC: new BehaviorValue(),

    ReadingMaterialLossThickness1: new BehaviorValue(),
    ReadingMaterialLossThickness2: new BehaviorValue(),
    ReadingMaterialLossThickness3: new BehaviorValue(),
    ReadingAreaZ: new BehaviorValue(),
  };
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface ReadingAppState {
  ReadingGateAmplitudeI: BehaviorValue<ReadingValue>;
  ReadingGateAmplitudeA: BehaviorValue<ReadingValue>;
  ReadingGateAmplitudeB: BehaviorValue<ReadingValue>;
  ReadingGateAmplitudeC: BehaviorValue<ReadingValue>;
  ReadingGateAmplitudeD: BehaviorValue<ReadingValue>;

  ReadingGatePositionI: BehaviorValue<ReadingValue>;
  ReadingGatePositionA: BehaviorValue<ReadingValue>;
  ReadingGatePositionB: BehaviorValue<ReadingValue>;
  ReadingGatePositionC: BehaviorValue<ReadingValue>;
  ReadingGatePositionD: BehaviorValue<ReadingValue>;

  ReadingCursorAmplitudeMMinusR: BehaviorValue<ReadingValue>;
  ReadingCursorUltrasoundMMinusR: BehaviorValue<ReadingValue>;
  ReadingCursorScanMMinusR: BehaviorValue<ReadingValue>;
  ReadingCursorIndexMMinusR: BehaviorValue<ReadingValue>;
  ReadingCursorScanD: BehaviorValue<ReadingValue>;
  ReadingCursorIndexD: BehaviorValue<ReadingValue>;

  ReadingThicknessGateI: BehaviorValue<ReadingValue>;
  ReadingThicknessGateA: BehaviorValue<ReadingValue>;
  ReadingThicknessGateB: BehaviorValue<ReadingValue>;
  ReadingThicknessGateC: BehaviorValue<ReadingValue>;
  ReadingThicknessGateD: BehaviorValue<ReadingValue>;

  ReadingThicknessGateIMinusGateA: BehaviorValue<ReadingValue>;
  ReadingThicknessGateIMinusGateB: BehaviorValue<ReadingValue>;
  ReadingThicknessGateIMinusGateC: BehaviorValue<ReadingValue>;
  ReadingThicknessGateIMinusGateD: BehaviorValue<ReadingValue>;

  ReadingThicknessGateAMinusGateI: BehaviorValue<ReadingValue>;
  ReadingThicknessGateAMinusGateB: BehaviorValue<ReadingValue>;
  ReadingThicknessGateAMinusGateC: BehaviorValue<ReadingValue>;
  ReadingThicknessGateAMinusGateD: BehaviorValue<ReadingValue>;

  ReadingThicknessGateBMinusGateI: BehaviorValue<ReadingValue>;
  ReadingThicknessGateBMinusGateA: BehaviorValue<ReadingValue>;
  ReadingThicknessGateBMinusGateC: BehaviorValue<ReadingValue>;
  ReadingThicknessGateBMinusGateD: BehaviorValue<ReadingValue>;

  ReadingThicknessGateCMinusGateI: BehaviorValue<ReadingValue>;
  ReadingThicknessGateCMinusGateA: BehaviorValue<ReadingValue>;
  ReadingThicknessGateCMinusGateB: BehaviorValue<ReadingValue>;
  ReadingThicknessGateCMinusGateD: BehaviorValue<ReadingValue>;

  ReadingThicknessGateDMinusGateI: BehaviorValue<ReadingValue>;
  ReadingThicknessGateDMinusGateA: BehaviorValue<ReadingValue>;
  ReadingThicknessGateDMinusGateB: BehaviorValue<ReadingValue>;
  ReadingThicknessGateDMinusGateC: BehaviorValue<ReadingValue>;

  ReadingMaterialLossThickness1: BehaviorValue<ReadingValue>;
  ReadingMaterialLossThickness2: BehaviorValue<ReadingValue>;
  ReadingMaterialLossThickness3: BehaviorValue<ReadingValue>;
  ReadingAreaZ: BehaviorValue<ReadingValue>;
}
/* eslint-enable @typescript-eslint/naming-convention */
